export default __webpack_public_path__ + "static/media/package-d-small.653be6f8.jpg";